// 格子单元类型定义
export interface Cell {
  value: number;
  color: string;
  id: string;
  keyId: string; // key id 格式
  isMatched?: boolean;
  isNew?: boolean;
  isIncremented?: boolean;
  isMovingToTarget?: boolean;
  isReviving?: boolean;
  targetPosition?: {
    row: number;
    col: number;
  };
}

// 持久化存储的格子单元类型（精简版）
export interface PersistentCell {
  value: number;
  id: string; // 简化的 id 格式
  keyId?: string; // key id 格式
  row: number; // 存储行索引
  col: number; // 存储列索引
}

// 分数弹出类型定义
export interface ScorePopup {
  id: string;
  score: number;
  x: number;
  y: number;
}

// 道具类型定义
export enum ItemType {
  RESET = 'RESET',       // 重置器
  SWAP = 'SWAP',         // 交换器
  UPGRADE = 'UPGRADE',   // 升级器
  RECOVER = 'RECOVER',   // 行动恢复剂
  REVIVE = 'REVIVE',     // 复活
  UPGRADE_ALL = 'upgradeAll' // 全场升级
}

// 道具数据类型
export interface Item {
  type: ItemType;
  count: number;
  icon: string;
  name: string;
  description: string;
}

// 道具提示消息类型
export interface ItemMessage {
  id: string;
  message: string;
  timestamp: number;
}

// 购物车商品类型
export interface CartItem {
  itemType: ItemType;
  quantity: number;
}

// 商店通知消息类型
export interface ShopMessage {
  id: string;
  message: string;
  type: 'success' | 'error' | 'info';
  timestamp: number;
}

// 游戏模式枚举
export enum GameMode {
  ENDLESS = 'ENDLESS',   // 无尽模式
  LEVEL = 'LEVEL'        // 通关模式
}

// 游戏状态接口
export interface GameState {
  mode: GameMode;        // 当前游戏模式
  currentLevel?: number; // 当前关卡ID（仅通关模式有效）
  totalScore: number;    // 历史总积分
  currentScore: number;  // 本场积分
  highestNumber: number; // 已消除的最高数字
  isLevelCompleted: boolean; // 关卡是否完成（仅通关模式有效）
}

// 关卡完成事件参数
export interface LevelCompletedEvent {
  levelId: number;       // 完成的关卡ID
  score: number;         // 获得的分数
  moves: number;         // 剩余行动点
  reward?: {             // 获得的奖励
    diamonds?: number;
    items?: { 
      type: string;
      count: number;
    }[];
  };
} 